import React from "react";
import { Formik, Form } from "formik";
import { Box, Button, Typography, TextField, Grid } from "@mui/material";
import * as Yup from "yup"; // For form validation
import "./care-needs.css";

// Validation schema using Yup
const validationSchema = Yup.object({
  careNeeds: Yup.string().required("Care needs are required"),
  contingencyPlan: Yup.string().required("Contingency plan is required"),
  supportOffered: Yup.string().required("Support offered is required"),
  requiredActions: Yup.string().required("Required actions are required"),
});

const CareNeeds = ({ updateFormData, nextStep, prevStep }) => {
  const initialValues = {
    careNeeds: "",
    contingencyPlan: "",
    supportOffered: "",
    requiredActions: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        updateFormData({ careNeedsInfo: values });
        nextStep(); // Move to next form
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
        <Form onSubmit={handleSubmit} className='form-container'>
          <Typography variant='h6' sx={{ fontWeight: "bold" }} align='left'>
            Care Needs (Including Cultural Needs)
          </Typography>
          <Typography variant='body2' gutterBottom mt={1}>
            Explain the reasons why this young person is being considered for placement.
          </Typography>
          {/* How will care needs be met? */}
          <Box mt={2}>
            <Typography sx={{ fontWeight: "bold" }} align='left'>
              How will care needs be met?
            </Typography>
            <Typography variant='body2' gutterBottom mt={1}>
              As above, consider all we can offer, in all key areas, additional resource ie psychology OT <br />
              etc. who else will meet need (family etc).
            </Typography>
            <TextField
              id='careNeeds'
              name='careNeeds'
              fullWidth
              multiline
              rows={4}
              value={values.careNeeds}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(touched.careNeeds && errors.careNeeds)}
              helperText={touched.careNeeds && errors.careNeeds ? errors.careNeeds : ""}
              variant='outlined'
            />
          </Box>

          {/* Contingency plan/additional resources */}
          <Box mt={3}>
            <Typography sx={{ fontWeight: "bold" }} align='left'>
              Contingency plan/additional resources
            </Typography>
            <TextField
              id='contingencyPlan'
              name='contingencyPlan'
              fullWidth
              multiline
              rows={4}
              value={values.contingencyPlan}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(touched.contingencyPlan && errors.contingencyPlan)}
              helperText={touched.contingencyPlan && errors.contingencyPlan ? errors.contingencyPlan : ""}
              variant='outlined'
            />
          </Box>

          {/* Support offered by all parties */}
          <Box mt={3}>
            <Typography sx={{ fontWeight: "bold" }} align='left'>
              Support offered by all parties
            </Typography>
            <TextField
              id='supportOffered'
              name='supportOffered'
              fullWidth
              multiline
              rows={4}
              value={values.supportOffered}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(touched.supportOffered && errors.supportOffered)}
              helperText={touched.supportOffered && errors.supportOffered ? errors.supportOffered : ""}
              variant='outlined'
            />
          </Box>

          {/* Required actions */}
          <Box mt={3}>
            <Typography sx={{ fontWeight: "bold" }} align='left'>
              Required actions
            </Typography>
            <Typography variant='body2' gutterBottom mt={1}>
              Include who isresponsible and desired completion date.
            </Typography>
            <TextField
              id='requiredActions'
              name='requiredActions'
              fullWidth
              multiline
              rows={4}
              value={values.requiredActions}
              onChange={handleChange}
              onBlur={handleBlur}
              error={Boolean(touched.requiredActions && errors.requiredActions)}
              helperText={touched.requiredActions && errors.requiredActions ? errors.requiredActions : ""}
              variant='outlined'
            />
          </Box>

          <Grid container justifyContent='space-between' alignItems='center' mt={2}>
            <Grid item>
              <Button type='button' variant='contained' color='primary' onClick={prevStep}>
                Previous
              </Button>
            </Grid>
            <Grid item>
              <Button type='submit' variant='contained' color='primary'>
                Next
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default CareNeeds;
